/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPagination } from "./api";

export interface IResponseListJob extends IPagination {
  jobs: IJob[];
}

export interface IResponseShowJob {
  job: IJob;
}

export enum ETypeJob {
  ROUTING = "ROUTING",
  TOWERMANAGEMENT_TRANSFEROFACTIVITY = "towerManagement-transferOfActivity",
  TOWERMANAGEMENT_UPDATEBYSPREADSHEET = "towerManagement-updateBySpreadsheet",
  TOWERMANAGEMENT_UPDATEGLOBALACTIVITY = "towerManagement-updateGlobalActivity",
  TOWERMANAGEMENT_CREATECHILDACTIVITY = "towerManagement-createChildActivity",
  TOWERMANAGEMENT_CREATEAPPROVALFLOW = "towerManagement-createApprovalFlow",
  TOWERMANAGEMENT_ASSIGNTEAMANDOUTSOURCED = "towerManagement-assignTeamAndOutsourced",
  TOWERMANAGEMENT_RETURNAFFECTEDSITECHANGETYPE = "towerManagement-returnAffectedSiteChangeType",
  TOWERMANAGEMENT_PROCESSSITECHANGETYPE = "towerManagement-processSiteChangeType",
  TOWERMANAGEMENT = "towerManagement-activityImport",
  TOWERMANAGEMENT_GENERATELPUSYTEX = "towerManagement-lpuSystex",
  GLOBALGENERATIONREPORT = "global-generationReport",
  GLOBALSENDWEBHOOK = "global-sendWebhook",
  FINANCIAL_ENTRYSETTLEDLOW = "financial-entrySettledLow",
  FINANCIAL_ENTRYCANCELED = "financial-entryCanceled",
  FINANCIAL_ENTRYSETTLEDLOWGROUPED = "financial-entrySettledLowGrouped",
  FINANCIAL_ENTRYCREATEDPAYMENTTERMS = "financial-entryCreatedPaymentTerms",
  TOWERMANAGEMENT_CREATEACCESSREQUEST = "towerManagement-createAccessRequest",
  TOWERMANAGEMENT_LPUINSERTIONBOT = "towerManagement-lpuInsertionBot",
}

export type TTypeJob = keyof ETypeJob;

export interface IJob {
  id: any;
  payload: any;
  cron?: string;
  idUser: string;
  type: ETypeJob;
  status?: "pending" | "in-progress" | "completed";
  logs: any[];
}
